export const APP_BUILD_INFO = {
  "appName": "webapp-react",
  "deployVersion": "v0.1+72.eef9d1e",
  "displayVersion": "v0.1+72",
  "builtAt": "2026-10-13T21:17:59.652Z",
  "buildNumber": "72",
  "commitSha": "eef9d1e",
  "gitBranch": "master",
  "packageVersion": "0.1.0"
} as const
